module.exports = __webpack_public_path__ + "img/error-illustration.c70ef885.svg";